import firebaseConfig from "./config"

class Firebase {
  constructor(app) {
    if (!firebaseInstance) {
      app.initializeApp(firebaseConfig)

      this.auth = app.auth()
      this.db = app.firestore()
      this.functions = app.functions()
      this.storage = app.storage()
    }
  }

  getUserProfile({ userId, onSnapshot }) {
    return this.db
      .collection("publicProfiles")
      .where("userId", "==", userId)
      .limit(1)
      .onSnapshot(onSnapshot)
  }

  async login({ email, password }) {
    return this.auth.signInWithEmailAndPassword(email, password)
  }

  async logout() {
    await this.auth.signOut()
  }

  async register({ email, password, name }) {
    await this.auth.createUserWithEmailAndPassword(email, password)
    const createPRofileCallable = this.functions.httpsCallable(
      "createPublicProfile"
    )
    return createPRofileCallable({ name })
  }

  async getGameList({ season, week }) {
    const getGameListCallable = this.functions.httpsCallable("getGameSchedule")
    return getGameListCallable({ season, week })
  }

  async postComment({ comment, eid }) {
    const postCommentCallable = this.functions.httpsCallable("postComment")
    return postCommentCallable({ comment, eid })
  }

  //2019100611
  subscribeToGameComments({ eid, onSnapshot }) {
    return this.db
      .collection("comments")
      .where("eid", "==", eid)
      .orderBy("created", "desc")
      .onSnapshot(data => {
        onSnapshot(data)
      })
  }
}

let firebaseInstance

function getFirebaseInstance(app) {
  if (!firebaseInstance && app) {
    firebaseInstance = new Firebase(app)
    return firebaseInstance
  } else if (firebaseInstance) {
    return firebaseInstance
  } else {
    return null
  }
}

export default getFirebaseInstance
